import axios from 'axios';
import API_CONFIG from '../config/apiConfig';
import encryptData from '../config/encryptConfig';

const API_BASE_URL = `${API_CONFIG.BASE_URL}/admin`;

/**
 * Adds a new officer user via the admin API.
 * @param {Object} officerData - Officer details (departmentId, userName, name, email, role, jurisdiction)
 * @param {string} token - Bearer token for authorization
 * @returns {Promise<Object>} API response data
 */

export const addOfficer = async (officerData) => {

 const payload={
  ...officerData,
  password:encryptData(officerData.password),
  email:encryptData(officerData.email),
  userName:encryptData(officerData.userName)
 }

  const token = localStorage.getItem('token');
  try {
    const response = await axios.post(`${API_BASE_URL}/officers`, payload, {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data : error;
  }
};

export const getOfficers = async () => {
  const token = localStorage.getItem('token');
  try {
    const response = await axios.get(`${API_BASE_URL}/officers`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data : error;
  }
};

export const deleteOfficer = async (id) => {
  const token = localStorage.getItem('token');
  return axios.delete(`${API_BASE_URL}/officers/${id}`, {
    headers: {
      Authorization: `Bearer ${token}`,
      accept: '*/*',
    },
  });
};

export const editOfficer = async (id, officerData) => {
  const token = localStorage.getItem('token');
  try {
    const response = await axios.put(
      `${API_BASE_URL}/officers/${id}`,
      officerData,
      {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
          accept: '*/*',
        },
      }
    );
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data : error;
  }
};
